export const CONSTANT = {
  // BASE_URL: "http://192.168.1.217:5012", //development
  // WS_URL: "ws://localhost:7443", //development WS
  // BASE_URL: "https://npg-api.vindaloosofttek.com", //development
  // WS_URL: "wss://npg-api.vindaloosofttek.com:7443", //development WS
  // BASE_URL: "http://192.168.1.237:5012",
  BASE_URL: "https://npg-api.paycall.co.il", //production
  WS_URL: "wss://npg-api.paycall.co.il:7443", //production WS

  DATE_FORMAT: "DD-MM-YYYY",
  TIME_FORMAT: "HH:mm",
  DATE_TIME_FORMAT: "DD-MM-YYYY HH:mm:ss",
  POST_DATE_FORMAT: "YYYY-MM-DD",
  POST_TIME_FORMAT: "HH:mm",
  POST_DATE_TIME_FORMAT: "YYYY-MM-DD HH:mm:ss",
  POST_DATE_HOURS_FORMAT: "YYYY-MM-DD HH",
  PORT_DATE_FORMATE: "YYYY-MM-DDTHH:mm:ss+03:00",
  PER_PAGE_RECORD: [10, 20, 50, 100],
  NO_DATA_FOUND: "No data found.",
  NOT_UPDATED: "Not Updated.",
  NO_MSG_FROM_PROVIDER: "No massage from provider.",

  NETWORK_TYPE: [
    { id: "M", value: "M" },
    { id: "F", value: "F" },
  ],
  NUMBER_TYPE: [
    { id: "S", value: "S" },
    { id: "R", value: "R" },
  ],
  PERMISSION_TYPE: ["admin", "write", "read"],
  PERMISSION_ARRAY: [
    { id: "admin", value: "Admin" },
    { id: "user", value: "User" },
  ],
  LANGUAGES: [
    { id: "english", value: "English" },
    { id: "hebrew", value: "Hebrew" },
  ],
  STAR_PROVIDER_STATUS: [
    { id: "completed", value: "Completed" },
    { id: "in progress", value: "In Progress" },
  ],
  PROVIDERS: [
    {
      id: "Network Provider",
      name: "Network Provider",
    },
    {
      id: "NOC Provider",
      name: "NOC Provider",
    },
    {
      id: "Support Provider",
      name: "Support Provider",
    },
  ],
  ALL_PROVIDERS: {
    NETWORK_PROVIDER: "Network Provider",
    NOC_PROVIDER: "NOC Provider",
    SUPPORT_PROVIDER: "Support Provider",
  },

  STATUS: [
    { id: "In Progress", value: "in progress" },
    { id: "Cancelled", value: "cancelled" },
    { id: "Completed", value: "completed" },
  ],

  WEBHOOKRESPONSE: [
    {
      id: "Success",
      value: "success",
    },
    {
      id: "Error",
      value: "error",
    },
  ],

  REPORTEDAPP: [
    {
      id: "SOAP-ACTION",
      value: "soap_server",
    },
    {
      id: "WORKER-ACTION",
      value: "np_worker",
    },
    {
      id: "API-ACTION",
      value: "api",
    },
    {
      id: "OTHER",
      value: "other",
    },
  ],
  REPORTEDAPP_LIST: {
    soap_server: "SOAP-ACTION",
    np_worker: "WORKER-ACTION",
    api: "API-ACTION",
    other: "OTHER",
  },

  PROVIDER_CODE: [
    {
      id: "PP",
      provider_code: "pp",
    },
    {
      id: "PC",
      provider_code: "pc",
    },
  ],

  INTERNAL_NUMBER_ROUTING_STATUS: [
    {
      id: "available",
      label: "Available",
    },
    {
      id: "in use for client",
      label: "In Use For Client",
    },
    {
      id: "in use internal",
      label: "In Use Internal",
    },
    {
      id: "reserved for client",
      label: "Reserver For Client",
    },
    {
      id: "freezed by client",
      label: "Freezed By Client",
    },
    {
      id: "freezed account",
      label: "Freezed Account",
    },
    {
      id: "ported",
      label: "Ported",
    },
  ],

  INTERNAL_NUMBER_ROUTING_PAYMENT_TYPE: [
    {
      id: "prepaid",
      label: "Prepaid",
    },
    {
      id: "postpaid",
      label: "Postpaid",
    },
  ],

  INTERNAL_NUMBER_ROUTING_SUBSCRIPTION_TYPE: [
    {
      id: "business",
      label: "Business",
    },
    {
      id: "private",
      label: "Private",
    },
    {
      id: "splitted business",
      label: "Splitted Business",
    },
    {
      id: "irrelevant",
      label: "Irrelevant",
    },
  ],

  INTERNAL_NUMBER_ROUTING_TYPE_OF_SERVICE: [
    {
      id: "M2M/IoT",
      label: "M2M/IoT",
    },
    {
      id: "regular",
      label: "Regular",
    },
    {
      id: "kosher",
      label: "Kosher",
    },
    {
      id: "data only",
      label: "Data Only",
    },
    {
      id: "irrelevant",
      label: "Irrelevant",
    },
  ],

  INTERNAL_NUMBER_ROUTING_INTERNAL_SERVICE: [
    {
      id: "available",
      label: "Available",
    },
    {
      id: "checkcall",
      label: "Checkcall",
    },
    {
      id: "pbx",
      label: "PBX",
    },
    {
      id: "callcenter",
      label: "Call center",
    },
    {
      id: "cellular",
      label: "Cellular",
    },
  ],
};
